export default __webpack_public_path__ + "static/media/calendar-time.80596808.svg";